export default __webpack_public_path__ + "static/media/SourceSansPro-Regular.c6130ac2.svg";